export default __webpack_public_path__ + "static/media/gridImg1.cf19a93b.jpg";